module.exports = __webpack_public_path__ + "img/indu_active_15.31b9051b.png";